<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:24
 * @LastEditors: lwq
 * @LastEditTime: 2020-08-04 19:38:16
--> 
<template>
  <div class="defaultClass">
    <v-pagination v-if="totalpage != 0"
                  style="width: 35vw;"
                  :value="cpage"
                  class="my-4"
                  :total-visible="8"
                  :length="totalpage"
                  light
                  @input='turnPage'
                  color="primary"></v-pagination>
  </div>

</template>

<script>
/**
 * 这是个 分页器
 * @params cpage 页码
 * @params totalpage 总页数
 * @event turnPage 页码改变的事件
 */
export default {
  components: {},
  props: {
    cpage: {
      type: Number,
      default: 1
    },
    totalpage: {
      type: Number,
      default: 0
    }
  },
  model: {
    prop: 'cpage',
    event: 'turnPage'
  },
  data () {
    return {

    };
  },
  created () { },
  mounted () { },
  methods: {
    turnPage (num) {
      this.$emit('turnPage', num)
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.defaultClass {
  display: flex;
  justify-content: flex-end;
}
</style>
